export default "__VITE_ASSET__CW87ZUMO__"